import {loadYmaps} from '../../ymapsloader.js';
import * as Vue from 'vue';
import {PointsList} from '../pointslist/pointslist.js';
// import {InputItem} from './inputitem.js';
import pointsIcon from '../../images/points.svg';
import pointsIconGray from '../../images/points-gray.svg';

import {useRoutingStore} from '../../store.js';
import {mapState, mapActions, mapGetters} from 'pinia';
import './mapcomponent.css'

//import { YMap, YMapControls, YMapControl, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } from '../../lib/ymaps';

import {  YMap,
          YMapHint,
          YMapDefaultSchemeLayer,
          YMapDefaultFeaturesLayer,
          YMapListener,
          YMapMarker,
          YMapControls,
          YMapControl,
          YMapFeature,
          YMapFeatureDataSource,
          YMapCollection,
          YMapDefaultMarker
} from '../../lib/ymaps';

import {
    BOUNDING_BOX_OPTIONS,
    drawLineOverMap,
    getBoundingBox,
    POLYGON_OPTIONS,
    transformCoordinates,
    INFO_MESSAGE_TEXT
} from '../common/common';

export const MapComponent = {
    data() {
        return {
            // Локальные данные компонента
            location: {
                // center: [65.537705, 57.151164],
                // zoom: 11
            },
            loading: true, // Так нужно, чтобы АПИ Яндекса загрузилось.
            drawMode: false,
            polygonCoordinates: null,
            boundingBoxCoordinates: null,
            showBoundingBox: false,
            refMap: null,
            deleteButton: true,
            pointsIcon,
            pointsIconGray
        };
    },

    components: {
        // InputItem
        PointsList,
        YMap,
        YMapHint,
        YMapDefaultSchemeLayer,
        YMapDefaultFeaturesLayer,
        YMapListener,
        YMapMarker,
        YMapControls,
        YMapControl,
        YMapFeature,
        YMapFeatureDataSource,
        YMapCollection,
        YMapDefaultMarker
    },        

    computed: {
        ...mapState(useRoutingStore, [
            'RLWaypoints',
            'RLStartPoint',
            'RLZoomPoint',
            'IsCycle',
            'RLRouteLineCoordinates',
            'clickedAddress',
            'selectedPoints',

        ]),
        deleteButtonCoordinates() {
            if (this.boundingBoxCoordinates) {
                const [lng, lat] = this.boundingBoxCoordinates[2];
                return [lng + 0.001, lat];
            }
            return null
        },


    },

    methods: {
        ...mapActions(useRoutingStore, [
            'setRouteLength',
            'setRouteDuration',
            'deleteWaypoint',
            'setClickedAddress',
            'clickedAddress',
            'editCoordinates',
            'addSelectedPoints',
            'deleteSelectedPoints'
        ]),

        setLocation(newCenter, newZoom = 11) {
            console.log('map setLocation');
            this.location = {
              center: newCenter,
              zoom: newZoom,
            }
        },

        async handleClick() {
            this.deleteButton = true
            this.handleDelete()
            this.drawMode = true;
            const mapEntity = this.$refs.yMap?.entity;
            if (!mapEntity) return;
            const coordinates = await drawLineOverMap(mapEntity);

            const bounds = this.getMapBounds();
            if (!bounds) {
                console.error('Не удалось получить границы карты');
                this.drawMode = false;
                return;
            }

            const transformedCoordinates = transformCoordinates(bounds, coordinates);

            this.polygonCoordinates = null;
            this.boundingBoxCoordinates = null;

            this.boundingBoxCoordinates = getBoundingBox(transformedCoordinates);
            this.deleteButton = false
            this.polygonCoordinates = transformedCoordinates;
            this.drawMode = false;
        },

        handleClickItem(item) {
            this.setClickedAddress(item)
        },
        onDragMoveHandler(coordinates, item){
            this.editCoordinates(coordinates, item)

        },

        handlePolygonClick () {
            this.showBoundingBox = true;
        },
        handleMapClick(object) {
            if (object?.type !== 'feature') {
                this.showBoundingBox = false;
            }
        },

        handleDelete() {
            this.polygonCoordinates = null;
            this.boundingBoxCoordinates = null;
            this.showBoundingBox = false;
        },
        getMapBounds() {
            const entity = this.$refs.yMap?.entity;
            if (entity && entity.bounds) {
                return entity.bounds;
            } else {
                console.warn('Карта ещё не готова или bounds недоступен');
                return null;
            }
        },
        isSelected(point){
            return this.selectedPoints.find(item => item.ID == point.ID)
        },
        isPointInPolygon(point, polygon) {
            const [x, y] = point.coordinates;
            let inside = false;

            for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                const [xi, yi] = polygon[i];
                const [xj, yj] = polygon[j];

                const intersect = yi > y !== yj > y &&
                    x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

                if (intersect) inside = !inside;
            }

            return inside;
        },
        selectPoints(points, polygon) {
            points.forEach(point => {
                if (!this.isPointInPolygon(point, polygon)) {
                    this.deleteSelectedPoints(point)
                    console.log(this.selectedPoints)
                }
            })
        },
        addPoints(points, polygon) {
            //console.log("addPoints")
            this.RLWaypoints.forEach(point => {
                if (this.isPointInPolygon(point, polygon)) {
                    this.addSelectedPoints(point)
                    //console.log(this.selectedPoints)
                }
            })
        }
    },

    async mounted() {

      console.log('map mounted');

      this.location = {
        center: [65.519883, 57.173947],
        zoom: 11,
      }

      // Проверяем периодически пока карта не загрузится
      // const checkMap = setInterval(() => {        
      //     if (this.$refs.yMap?.entity) {
      //         this.refMap = this.$refs.yMap?.entity;
      //         // console.log('this.$refs.yMap:', this.$refs.yMap);
      //         // console.log('this.refMap:', this.refMap);
      //         // console.log('Тип refMap:', typeof this.refMap);
      //         // console.log('Методы refMap:', Object.keys(this.refMap || {}));
      //         window.mapComponent = this;
      //         clearInterval(checkMap);
      //     } else {
      //     }
      // }, 100);

      this.refMap = this.$refs.yMap?.entity;
      //console.log(this.refMap);
      window.map = this.refMap;
      // Делаем компонент глобально доступным
      window.mapComponent = this;        
      try {
          this.loading = false;
          //console.log('ymaps3 version:', ymaps3.version);
          //this.$forceUpdate();
      } catch (error) {
        console.error("Ошибка при загрузке Yandex Maps API", error);
      }
    },

    beforeUnmount() {
        // Чистим при размонтировании
        window.mapComponent = null;
    },

    // language=Vue
    template: `
      <div :style="{width: '100%', height: '100%'}">

        <div v-if="loading">Загрузка карты...</div>
        
        <YMap v-else
              :location="RLZoomPoint ? { center: RLZoomPoint, zoom: 15 } : location"
              showScaleInCopyrights
              ref="yMap"
        >
          <YMapDefaultSchemeLayer/>
          <YMapDefaultFeaturesLayer/>
          
          <template v-for="(step, index) in RLRouteLineCoordinates">
            <YMapFeature
                v-if="step.length > 0"
                :geometry="{
                    type: 'LineString',
                    coordinates: step
                    }"
                :style="{ stroke: [{ color: '#46d930', width: 6 }] }"
            />
          </template>
          
          <template v-if="RLStartPoint">
            <YMapDefaultMarker
                :coordinates="RLStartPoint['coordinates']"
                :title="RLStartPoint.title"
                :subtitle="RLStartPoint.title"
                :draggable="false"
                :size="'small'"
                :iconName="'fallback'"
            />
          </template>

          <template v-for="(item, index) in RLWaypoints" :key="item.ID">
            <template v-if="isSelected(item)">
            <YMapMarker
                :coordinates="item['coordinates']"
                :key="index"
                :title="'Точка № ' + (index+1)"
                :subtitle="item.title"
                :draggable="false"
                @drag-move="(coords) => onDragMoveHandler(coords, item.ID)"
                :size="small"
                :iconName="landmark"
                @click="handleClickItem(item, index)"
            >
              <template v-if="item.ID !== RLStartPoint.ID ">
                <div class="custom-marker">
                  <div class="text-label">
                    {{ item.title }}
                  </div>
                  <div class="marker-label">
                    <div class="number-label">
                      {{ index + 1 }}
                    </div>
                  </div>
                  <img class="icon" :src="pointsIcon" alt="dots icon">                  
                </div>

              </template>
              
            </YMapMarker>
            </template>
          </template>

          <template v-for="(item, index) in RLWaypoints" :key="item.ID">
            <YMapMarker
                :coordinates="item['coordinates']"
                :key="index"
                :title="'Точка № ' + (index+1)"
                :subtitle="item.title"
                :draggable="false"
                @drag-move="(coords) => onDragMoveHandler(coords, item.ID)"
                :size="small"
                :iconName="landmark"
                @click="handleClickItem(item, index)"
            >
              <template v-if="item.ID !== RLStartPoint.ID ">
                <div class="custom-marker custom-marker-grey">
                  <img class="icon" :src="pointsIconGray" alt="dots icon">
                  <!--<div class="text-label">
                    {{ item.title }}
                  </div>
                  <div class="marker-label">
                    <div class="number-label">
                      {{ index + 1 }}
                    </div>
                  </div>-->
                </div>
              </template>
              
            </YMapMarker>
          </template>

          <YMapControls position="top right">
            <YMapControl>
            <div class = "points-list">
              <div style="display: flex; flex-direction: column; gap: 1rem;">
                <div class="ymap-container-controll_center">
                  <PointsList/>
                </div>
              </div>
            </div>
            </YMapControl>
          </YMapControls>

          <YMapFeature
              v-if="polygonCoordinates"
              :geometry="{
            type: 'Polygon',
            coordinates: [polygonCoordinates]
          }"
              :style="POLYGON_OPTIONS"
              @click="handlePolygonClick"
          />
          <YMapFeature
              v-if="boundingBoxCoordinates && showBoundingBox"
              :geometry="{
            type: 'Polygon',
            coordinates: [boundingBoxCoordinates]
          }"
              :style="BOUNDING_BOX_OPTIONS"
          />
          
          <!-- Кнопки лассо -->
          <YMapControls position="top left">
            <YMapControl>
              <div style="display: flex; gap: 10px;">
                <button
                    :class="{'addPointsButton': true, active: addButton}"
                    :disabled="addButton"
                    @click="addPoints(selectedPoints, polygonCoordinates)"
                >
                  {{addButton ? 'Выберите зону' : 'Добавить точки'}}
                </button>
                <button
                    :class="{'deletePointsButton': true, active: deleteButton}"
                    :disabled="deleteButton"
                    @click="selectPoints(selectedPoints, polygonCoordinates)"
                >
                  {{deleteButton ? 'Выберите зону' : 'Удалить точки'}}
                </button>
                <button
                    :class="{'draw-button': true, active: drawMode}"
                    :disabled="drawMode"
                    @click="handleClick"
                >
                  {{drawMode ? 'Выделите область' : 'Снять выделение'}}
                </button>
              </div>
            </YMapControl>
          </YMapControls>

          <YMapListener @click="handleMapClick" />

        </YMap>
        
        <canvas id="draw-canvas" class="canvas"></canvas>
        
      </div>
    `
};

